// extracted by mini-css-extract-plugin
export default {"body":"ForgottenPasswordSent_body__JONDF"};